/**
 * 日付文字列を画面表示用にフォーマットする関数
 * @param {string} dateTimeString - 日付文字列（例: "2023-10-05T14:48:00" または "2023-10-05"）
 */
export const formatDateForDisplay = (dateTimeString) => {
    if (!dateTimeString) return '';
    
    // 日付部分を取得
    let datePart = '';
    
    if (dateTimeString.includes('T')) {
        datePart = dateTimeString.split('T')[0];
    } else {
        datePart = dateTimeString;
    }
    
    // ハイフン形式をスラッシュ形式に変換（画面表示用）
    if (datePart.includes('-')) {
        return datePart.replace(/-/g, '/');
    }
    
    return datePart;
}

/**
 * 日付文字列をAPI送信用にフォーマットする関数
 * @param {string} dateTimeString - 日付文字列（例: "2023-10-05"）
 */
export const formatDateForApi = (dateTimeString) => {
    return (dateTimeString ?? '').replace(/-/g, '/');
}